import React from 'react';

import BorderColorIcon from '@material-ui/icons/BorderColor';
import Skeleton from '@material-ui/lab/Skeleton';
import cx from 'classnames';
import { range } from 'lodash';

import { colors } from 'theme/palette';

import Button from 'components/Button';
import Typography from 'components/Typography';

import styles from './styles.module.scss';

const MatchedBulkUploadGroup = ({
  disabled,
  bulkUploadGroup,
  onClick,
  showSkeleton,
  tasksIds
}) => (
  <>
    {bulkUploadGroup.bulk_upload_images.map((bulkUploadImage, index) => (
      <div
        key={bulkUploadImage.id}
        className={cx(
          styles.container,
          { [styles.disabled]: disabled },
          { [styles.columnStart]: index === 0 }
        )}
        onClick={disabled ? undefined : () => onClick(bulkUploadImage, index)}
      >
        <img src={bulkUploadImage.file_url} alt="bulk upload preview" />

        <div className={styles.buttonContainer}>
          <Button
            disabled={disabled}
            variant="small"
            color="grey"
            className={cx(styles.button, { [styles.hidden]: index !== 0 })}
            classes={{ label: styles.label }}
            endIcon={
              <BorderColorIcon
                style={{ color: colors.blue3 }}
                classes={{ root: styles.editIcon }}
              />
            }
          >
            {bulkUploadGroup.student.name}
          </Button>
          <Typography
            variant="S-TEXT-1"
            display="inline"
            className={styles.element}
          >
            {tasksIds?.indexOf(bulkUploadImage.task.id) + 1}
          </Typography>
        </div>
      </div>
    ))}
    {showSkeleton &&
      range(bulkUploadGroup.unprocessed_images_count).map((index) => (
        <Skeleton key={index} height={262} width={250} variant="rect" />
      ))}
  </>
);

export default MatchedBulkUploadGroup;
